<template>
  <b-row>
    <b-colxx xxs="12">
      <b-card class="mb-4 weight600" title="판매정보">
        <div class="mb-4">

          <!-- 상품 유형 -->
          <b-row style="min-height:35px;" align-v="center" class="justify-content-start mt-3" no-gutters>
            <b-col md="2" class="align-middle">
              <span class="spnaW">상품 유형</span>
            </b-col>
            <b-col md="2">
              <span>{{ goodsType!= null? _goodsTypeOption.find(x => x.value == goodsType).text : ''}}</span>
            </b-col>
          </b-row>

          <!-- 유효기간(사용조건) -->
          <b-row v-if="goodsType != 'Booking'" style="min-height:35px;" align-v="center"
                 class="justify-content-start mt-3" no-gutters>
            <b-col md="2" class="align-middle">
              <span class="spnaW">유효기간(사용조건)</span>
            </b-col>

            <b-col>
              <span>{{expirationDateSetting == 'SetFromToDate'?
                 this.$moment(validFromDate).format('YYYY-MM-DD') + ' ~ ' + this.$moment(validToDate).format('YYYY-MM-DD')
                : '구매 후 ' + validDayCount + '일'}}</span>
            </b-col>
          </b-row>

          <!-- 취소기한(사용조건) -->
          <b-row v-if="goodsType != 'Booking'" style="min-height:35px;" align-v="center" class="justify-content-start mt-3" no-gutters>
            <b-col md="2" class="align-middle">
              <span class="spnaW">취소기한(사용조건)</span>
            </b-col>
            <b-col>
              <span>{{cancellableTimeValue ==0? '취소불가' : '취소가능 '+ cancellableTimeValue +"일"}}</span>
            </b-col>
          </b-row>


          <!-- 최대이용매수 -->
          <b-row style="min-height:35px;" align-v="center" class="justify-content-start mt-3" no-gutters>
            <b-col md="2">
              <span class="spnaW">최대 이용매수</span>
            </b-col>

            <b-col>
              <b-form inline>
                <b-form-group>
                  <b-form-radio-group
                    v-model="_limitedMaxNumToUse"
                    :options="[{ value: true , text: '제한없음' }, { value: false , text: '제한' } ]"/>
                </b-form-group>
              </b-form>
            </b-col>

            <b-col v-if="!_limitedMaxNumToUse && _limitedMaxNumToUse != null" md="8">
              <b-form inline>
                최대
                <b-form-input v-model="_maxNumToUse" type="text" class="ml-2 mr-2 p-2" style="width:35px; height:30px;"/>
                매 사용 가능
              </b-form>
            </b-col>
          </b-row>

          <!-- 사전예약필수 -->
          <b-row v-if="goodsType != 'Booking' && goodsType != 'BookingCoupon' " style="min-height:35px;" align-v="center"
                 class="justify-content-start mt-3" no-gutters>
            <b-col md="2">
              <span class="spnaW">사전예약 필수</span>
            </b-col>

            <b-col>
              <b-form inline>
                <b-form-group>
                  <b-form-radio-group
                    v-model="_requiredPreBooking"
                    :options="[
                { value: true , text: '사용안함' },
                { value: false , text: '사용' } ]"
                  ></b-form-radio-group>
                </b-form-group>
              </b-form>
            </b-col>

            <b-col v-if="!_requiredPreBooking && _requiredPreBooking != null" md="8">
              <b-form inline>
                최소
                <b-form-input v-model="_preBookingDaysAgo" type="text" class="ml-2 mr-2"
                              style="width:35px; height:30px;"/>
                일 전까지 사전예약 필수
              </b-form>
            </b-col>
          </b-row>

          <!-- 소인기준 -->
          <b-row style="min-height:35px;" align-v="center" class="justify-content-start mt-3" no-gutters>
            <b-col md="2" class="align-middle spnaW">
              소인기준
            </b-col>
            <b-col>
              <b-form inline>
                <b-form-group>
                  <b-form-radio-group
                    v-model="_useRuleKid"
                    :options="[
                { value: false , text: '노출안함'},
                { value: true , text: '노출함' } ]"
                  ></b-form-radio-group>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col v-if="_useRuleKid && _useRuleKid != null" md="8">
              <b-form inline>
                <b-form-input v-model="_ruleKidAgeRange[0]" type="text" class="ml-2 mr-2"
                              style=" height:30px;"/>
<!--                세 ~-->
<!--                <b-form-input v-model="_ruleKidAgeRange[1]" type="text" class="ml-2 mr-2"-->
<!--                              style="width:35px; height:30px;"/>-->
<!--                세-->
              </b-form>
            </b-col>
          </b-row>

          <!-- 주차안내 -->
          <b-row style="min-height:35px;" align-v="center" class="justify-content-start mt-3" no-gutters>
            <b-col md="2" class="align-middle spnaW">
              주차안내
            </b-col>
            <b-col md="2">
              <b-form inline>
                <b-form-group>
                  <b-form-radio-group
                    v-model="_parkingGuide"
                    :options="[
                { value: false , text: '주차불가'},
                { value: true , text: '주차가능' } ]"
                  ></b-form-radio-group>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col v-if="_parkingGuide" md="8">
              <b-form inline>
                <b-form-input v-model="_parkingGuideText" type="text" class="ml-2 mr-2"
                              style="width:500px; height:30px;"/>
              </b-form>
            </b-col>
          </b-row>

          <!-- 운영시간 -->
          <b-row style="min-height:35px;" align-v="center" class="justify-content-start mt-3" no-gutters>
            <b-col md="2" class="align-middle spnaW">
              운영시간 노출
            </b-col>
            <b-col md="2">
              <b-form inline>
                <b-form-group>
                  <b-form-radio-group
                    v-model="_showOperatingTime"
                    :options="[
                { value: false , text: '비노출'},
                { value: true , text: '노출' } ]"
                  ></b-form-radio-group>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col v-if="_showOperatingTime" md="8">
              <b-form inline>
                <b-form-input v-model="_showOperatingTimeText" type="text" class="ml-2 mr-2"
                              style="width:500px; height:30px;"/>
              </b-form>
            </b-col>

          </b-row>
        </div>


        <b-row>
          <b-col align="center">
            <b-button variant="primary" @click="createShowInfo">판매정보 자동 생성</b-button>
          </b-col>
        </b-row>


        <b-row style="min-height:35px;" align-v="center" class="justify-content-start mt-3" no-gutters>

          <b-col md="2" class="align-middle">
            <span>사용정보</span>
          </b-col>
        </b-row>
        <b-row style="min-height:35px;" align-v="center" class="justify-content-start" no-gutters>

          <b-col>
            <b-form>
              <b-form-group class="w-100">
                <b-textarea v-model="_usePolicyStr" style="width:97%" :rows="5" :max-rows="5"/>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>


        <b-row style="min-height:35px;" align-v="center" class="justify-content-start mt-3" no-gutters>
          <b-col md="2" class="align-middle">
            <span>기본정보</span>
          </b-col>
        </b-row>

        <b-row style="min-height:35px;" align-v="center" class="justify-content-start" no-gutters>
          <b-col>
            <b-form>
              <b-form-group class="w-100">
                <b-textarea v-model="_basicPolicyStr" style="width:97%" :rows="5" :max-rows="5"/>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>

        <b-row style="min-height:35px;" align-v="center" class="justify-content-start mt-3" no-gutters>
          <b-col md="2" class="align-middle">
            <span>유의사항</span>
          </b-col>
        </b-row>

        <b-row style="min-height:35px;" align-v="center" class="justify-content-start" no-gutters>
          <b-col>
            <b-form>
              <b-form-group class="w-100">
                <b-textarea v-model="_cautionPolicyStr" style="width:97%" :rows="5" :max-rows="5"/>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>

        <b-row style="min-height:35px;" align-v="center" class="justify-content-start mt-3" no-gutters>
          <b-col md="2" class="align-middle">
            <span>취소/환불 규정</span>
          </b-col>
        </b-row>

        <b-row style="min-height:35px;" align-v="center" class="justify-content-start" no-gutters>
          <b-col>
            <b-form>
              <b-form-group class="w-100">
                <b-textarea v-model="_cancellationRefundPolicyStr" style="width:97%" :rows="5" :max-rows="5"/>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>

        <div class="mb-5"></div>

        <!-- SOURCE -->
        <!--        <div ref="printMe" class="p-5" style="background: #eee">-->
        <!--          <div>-->
        <!--            <h1 style="width: 100%;color: #000;" align="center">상품 이용안내</h1>-->
        <!--          </div>-->
        <!--          <p>사용정보</p>-->
        <!--          <p>{{ myfilter(_usePolicyStr) }}</p>-->
        <!--          <p>기본정보</p>-->
        <!--          <p>{{ myfilter(_basicPolicyStr) }}</p>-->
        <!--          <p>유의사항</p>-->
        <!--          <p>{{ myfilter(_cautionPolicyStr) }}</p>-->
        <!--          <p>취소/환불 규정</p>-->
        <!--          <p>{{ myfilter(_cancellationRefundPolicyStr) }}</p>-->

        <!--        </div>-->

        <!--        <div class="mt-3 mb-3">-->
        <!--          <b-button class="ml-1" @click="print" variant="primary">이미지 저장</b-button>-->
        <!--        </div>-->
        <!-- OUTPUT -->
        <!--        <div class="mb-5" align="center">-->
        <!--          <a :href="output" download="policy-image.png">-->
        <!--            <img id="outputImage" style="width:960px" :src="output"/>-->
        <!--          </a>-->
        <!--        </div>-->

      </b-card>
    </b-colxx>
  </b-row>
</template>


<script>
  import {
    mapGetters,
    mapActions,
    mapMutations
  } from "vuex";

  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css'


  export default {
    components: {
      'v-select': vSelect,
    },

    data() {
      return {
        isModifyMode: false,
        isReqModifyMode: false,
        goodsParamsId: null, //등록된 상품아이디
        registerId: null, //등록대기 상품아이디
        copyRegisterId: null,
        output: null,
        imageOutput: null,
      }
    },
    watch: {
      _usePolicy() {
      },
      _basicPolicy() {
      },
      _cancellationRefundPolicy() {
      },
    },

    computed: {
      ...mapGetters([
        'currentUser',
        'siteName',

        'goodsType', //상품유형
        'goodsTypeOption',//상품유형옵션

        'expirationDateSetting', //유효시간
        'validDayCount', 'validFromDate', 'validToDate',
        'cancellableTimeSetting', //취소기한
        'cancellableTimeValue',

        'limitedMaxNumToUse', //최대이용매수 제한
        'maxNumToUse', //최대이용매수
        'requiredPreBooking', //사전예약필수 제한
        'preBookingDaysAgo', //사전예약필수일
        'useRuleKid', //소인기준노출
        'ruleKidAgeRange', //소인기준나이[]
        'parkingGuide', //주차가능여부
        'parkingGuideText', //주차가능텍스트
        'showOperatingTime', //운영시간노출여부
        'showOperatingTimeText', //운영시간노출여부
        //판매정보
        'usePolicy',
        'basicPolicy',
        'cautionPolicy',
        'cancellationRefundPolicy',
        'usePolicyStr',
        'basicPolicyStr',
        'cautionPolicyStr',
        'cancellationRefundPolicyStr',


      ]),
      _goodsTypeOption: {
        get() {
          return this.goodsTypeOption
        },
      },

      _limitedMaxNumToUse: {
        get: function() {
          return this.limitedMaxNumToUse
        }, set: function(e) {
          this.setLimitedMaxNumToUse(e)
        }
      },
      _maxNumToUse: {
        get: function() {
          return this.maxNumToUse
        }, set: function(e) {
          this.setMaxNumToUse(e)
        }
      },
      _requiredPreBooking: {
        get: function() {
          return this.requiredPreBooking
        }, set: function(e) {
          this.setRequiredPreBooking(e)
        }
      },
      _preBookingDaysAgo: {
        get: function() {
          return this.preBookingDaysAgo
        }, set: function(e) {
          this.setPreBookingDaysAgo(e)
        }
      },
      _useRuleKid: {
        get: function() {
          return this.useRuleKid
        }, set: function(e) {
          this.setUseRuleKid(e)
        }
      },
      _ruleKidAgeRange: {
        get: function() {
          return this.ruleKidAgeRange
        }, set: function(e) {
          this.setRuleKidAgeRange(e)
        }
      },
      _parkingGuide: {
        get: function() {
          return this.parkingGuide
        }, set: function(e) {
          this.setParkingGuide(e)
        }
      },
      _parkingGuideText: {
        get: function() {
          return this.parkingGuideText
        }, set: function(e) {
          this.setParkingGuideText(e)
        }
      },
      _showOperatingTime: {
        get: function() {
          return this.showOperatingTime
        }, set: function(e) {
          this.setShowOperatingTime(e)
        }
      },

      _showOperatingTimeText: {
        get: function() {
          return this.showOperatingTimeText
        }, set: function(e) {
          this.setShowOperatingTimeText(e)
        }
      },


      _usePolicy: {
        get: function() {
          return this.usePolicy
        }, set: function(e) {
          this.setUsePolicy(e)
        }
      },
      _basicPolicy: {
        get: function() {
          return this.basicPolicy
        }, set: function(e) {
          this.setBasicPolicy(e)
        }
      },
      _cautionPolicy: {
        get: function() {
          return this.cautionPolicy
        }, set: function(e) {
          this.setCautionPolicy(e)
        }
      },
      _cancellationRefundPolicy: {
        get: function() {
          return this.cancellationRefundPolicy
        }, set: function(e) {
          this.setCancellationRefundPolicy(e)
        }
      },

      _usePolicyStr: {
        get: function() {
          return this.usePolicyStr
        }, set: function(e) {
          this.setUsePolicyStr(e)
        }
      },
      _basicPolicyStr: {
        get: function() {
          return this.basicPolicyStr
        }, set: function(e) {
          this.setBasicPolicyStr(e)
        }
      },
      _cautionPolicyStr: {
        get: function() {
          return this.cautionPolicyStr
        }, set: function(e) {
          this.setCautionPolicyStr(e)
        }
      },
      _cancellationRefundPolicyStr: {
        get: function() {
          return this.cancellationRefundPolicyStr
        }, set: function(e) {
          this.setCancellationRefundPolicyStr(e)
        }
      },

    },
    mounted() {

      //신규상품
      this.registerId = this.$route.params.registerId !== undefined ? this.$route.params.registerId : null
      if(this.registerId !== null) {
        this.isReqModifyMode = true
      }

      //등록상품
      this.goodsParamsId = this.$route.params.goodsId !== undefined ? this.$route.params.goodsId : null
      if(this.goodsParamsId !== null) {
        this.isModifyMode = true
      }

      // this.goodsShowInfo({currentUser: this.currentUser, siteName: this.siteName})

    },

    methods: {
      ...mapMutations([
        'setLimitedMaxNumToUse',
        'setMaxNumToUse',
        'setRequiredPreBooking',
        'setPreBookingDaysAgo',
        'setUseRuleKid',
        'setRuleKidAgeRange',
        'setParkingGuide',
        'setParkingGuideText',
        'setShowOperatingTime',
        'setShowOperatingTimeText',
        'setUsePolicy',
        'setBasicPolicy',
        'setCautionPolicy',
        'setCancellationRefundPolicy',
        'setUsePolicyStr',
        'setBasicPolicyStr',
        'setCautionPolicyStr',
        'setCancellationRefundPolicyStr',
      ]),
      ...mapActions(['goodsShowInfo']),

      defaultSetting() {


      },

      async print() {
        const el = this.$refs.printMe
        const options = {type: 'dataURL'}
        this.output = await this.$html2canvas(el, options)
      },


      createShowInfo() {
        if(confirm("입력된 정보 기반으로 판매정보를 자동 생성 하시겠습니까?\n" +
          "(기존에 입력된 정보는 초기화됩니다.)\n")) {

          this.goodsShowInfo({currentUser: this.currentUser, siteName: this.siteName})


        }


      }

    }
  }
</script>
